import { TabPane } from 'reactstrap';

import { CoordinatorsTabContent } from './coordinators-tab-content';
import { InternshipLocationsTabContent } from './internship-locations-tab-content';
import { PreceptorsTabContent } from './preceptors-tab-content';
import { StudentsTabContent } from './students-tab-content';
import { TeachersTabContent } from './teachers-tab-content';

interface IProps {
  groupId: string;
}

export const GroupSettingsTabPanes = ({ groupId }: IProps) => {
  return (
    <>
      <TabPane tabId="coordinators" id="coordinators">
        <CoordinatorsTabContent groupId={groupId} />
      </TabPane>
      <TabPane tabId="teachers" id="teachers">
        <TeachersTabContent groupId={groupId} />
      </TabPane>
      <TabPane tabId="preceptors" id="preceptors">
        <PreceptorsTabContent groupId={groupId} />
      </TabPane>
      <TabPane tabId="students" id="students">
        <StudentsTabContent groupId={groupId} />
      </TabPane>
      <TabPane tabId="internship-locations" id="internship-locations">
        <InternshipLocationsTabContent groupId={groupId} />
      </TabPane>
    </>
  );
};
